import { produce } from "immer";

import { courseTypes as types } from "../actions";
import { EducatorCourseStateType } from "../../../utils";

const defaultState: EducatorCourseStateType = {
  courses: [],
  course: null,
  loaded: false,
  loading: false,
  submitLoading: false,
};

const handleSetCourse = (state: any, payload: any) => {
  state.course = payload.course;
  state.loading = false;
  return state;
};

const handleSetCourses = (state: any, payload: any) => {
  state.courses = payload.courses;
  state.loading = false;
  state.loaded = true;
  return state;
};

export default produce(
  (state: EducatorCourseStateType = defaultState, action) => {
    switch (action.type) {
      case types.SET_COURSE:
        return handleSetCourses(state, action.payload);
      case types.SET_COURSE_BY_ID:
        return handleSetCourse(state, action.payload);
      case types.GET_COURSE:
        return {
          ...state,
          loading: true,
        };
      case types.GET_COURSE_BY_ID:
        return {
          ...state,
          loading: true,
        };
      case types.IS_LOADING:
        return {
          ...state,
          submitLoading: action.payload,
        };
      default:
        return state;
    }
  }
);
